import { Badge, Group, Stack, Text } from "@mantine/core";
import { IconPlane, IconShield } from "@tabler/icons-react";
import TravellerDrawerRow from "./TravellerDrawerRow";
import TravellerDrawerSection from "./TravellerDrawerSection";
import { formatPolicyDate, purchaseMethodLabel } from "../../utils/allPolicyHelpers";
import classes from "./TravellerPolicyDrawer.module.css";

const TravellerDrawerCoverage = ({ traveller }) => {
  if (!traveller) return null;
  const duration = traveller.duration != null ? `${traveller.duration} days` : "—";

  return (
    <Stack gap="lg">
      {!traveller.issued_policy_number ? (
        <Text size="sm" c="dimmed" fs="italic">No policy number issued yet.</Text>
      ) : null}

      <div className={classes.finCard} style={{ background: "#FFF4E8", maxWidth: 160 }}>
        <Text fw={700} c="orange.7">{duration}</Text>
        <Text size="xs" c="dimmed" tt="uppercase">Duration</Text>
      </div>

      <TravellerDrawerSection icon={IconShield} label="Coverage Details">
        <TravellerDrawerRow label="Cover Name" value={traveller.cover_name} />
        <Group justify="space-between" py={6}>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>Cover Type</Text>
          <Badge variant="light" color="grape">{traveller.cover_type || "—"}</Badge>
        </Group>
        <TravellerDrawerRow label="Start Date" value={formatPolicyDate(traveller.coverage_start_date)} />
        <TravellerDrawerRow label="End Date" value={formatPolicyDate(traveller.coverage_end_date)} />
        <TravellerDrawerRow label="Issued On" value={formatPolicyDate(traveller.cover_issued_dt)} />
        <TravellerDrawerRow label="Policy Status" value={traveller.policy_status} />
        <TravellerDrawerRow
          label="Purchase"
          value={purchaseMethodLabel(traveller.purchase_method)}
          highlight="#033F7C"
        />
        <TravellerDrawerRow
          label="Trip ID"
          value={traveller.trip_id ? `#${traveller.trip_id}` : "—"}
          highlight="orange"
        />
        <TravellerDrawerRow label="Booking ID" value={traveller.booking_id} />
        <TravellerDrawerRow
          label="Doc Status"
          value={String(traveller.document_verification_status ?? "—")}
        />
      </TravellerDrawerSection>

      <TravellerDrawerSection icon={IconPlane} label="Journey">
        <TravellerDrawerRow label="From" value={traveller.traveller_from_name} />
        <TravellerDrawerRow label="To" value={traveller.traveller_to_name} />
        <TravellerDrawerRow label="Operator" value={traveller.tour_operator_name} />
      </TravellerDrawerSection>
    </Stack>
  );
};

export default TravellerDrawerCoverage;
